import { BookOpen, ClipboardCheck, Code2, Flag, Terminal, type LucideIcon } from 'lucide-react';

import type { ActivityKind } from '@mio/shared';

export const ACTIVITY_KIND: Record<
  ActivityKind,
  { label: string; environment: 'Studio' | 'Workshop' | 'Workbench'; icon: LucideIcon }
> = {
  lesson: { label: 'Lesson', environment: 'Studio', icon: BookOpen },
  workshop: { label: 'Workshop', environment: 'Workshop', icon: Code2 },
  field_beat: { label: 'Workbench beat', environment: 'Workbench', icon: Terminal },
  checkpoint: { label: 'Checkpoint', environment: 'Studio', icon: ClipboardCheck },
  field_day: { label: 'Workbench day', environment: 'Workbench', icon: Flag },
};

/** Activities the learner can open today. Workbench activities open once that flow is built. */
export function isOpenable(kind: ActivityKind): boolean {
  return kind === 'lesson' || kind === 'checkpoint' || kind === 'workshop';
}

/** Where an activity opens: lessons and checkpoints in Studio, workshops in Workshop. */
export function activityHref(kind: ActivityKind, id: string): string {
  return kind === 'workshop' ? `/workshop/${id}` : `/studio/${id}`;
}

export function formatMinutes(minutes: number | null | undefined): string | null {
  if (!minutes) return null;
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}
